import { createUseStyles } from "react-jss";
import { inputMinWidth, inputMaxWidth, getSpacing } from "../../theme/Mixins";

export default createUseStyles((theme: any) => ({
    inputWrapper: {
        alignItems: "center",
        composes: "input-wrapper",
        display: "flex",
        marginTop: ({ theme }) => getSpacing(theme, 0, theme.QuestionSpacing?.WithinComponents),
    },
    inputWrapperLabel: {
        composes: "input-wrapper__label",
    },
    inputWrapperLabelLeft: {
        composes: "input-wrapper__label-left",
        marginRight: 14.5,
    },
    inputWrapperLabelRight: {
        composes: "input-wrapper__label-right",
        marginLeft: 14.5,
    },
    inputWrapperControl: ({ size }) => ({
        composes: "input-wrapper__control",
        flex: 1,
        maxWidth: inputMaxWidth(theme, size),
        minWidth: inputMinWidth(theme, size),
    }),
}));
